import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'
import {createClient} from 'sanity-codegen'

type TSanityClientConfig = Parameters<typeof createClient>

export const sanityClientConfig: TSanityClientConfig['0'] = {
	projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
	dataset: process.env.NEXT_PUBLIC_SANITY_DB,
	fetch,
	token: process.env.SANITY_TOKEN,
	useCdn: true,
	apiVersion: '2021-03-25',

	// by default sanity-codegen caches responses in memory. this can be disabled if desired
	// disabledCache: true,
}

const builder = imageUrlBuilder(sanityClientConfig)

export function getImageBuilderFor(source: Parameters<typeof builder.image>['0']) {
	return builder.image(source)
}
const client = sanityClient(sanityClientConfig)

export default client
